import { Box, Card, CardContent, CardHeader, CardProps, Tooltip } from "@mui/material";
import React, { ReactNode } from "react";
import { AppInfoIcon } from "ui/Scripts/source/components/framework/Icon/AppInfoIcon";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "source/framework/appUtils";
import { Base } from "ui/Scripts/source/framework/base";

export const DialogSectionCard = ({
    headerTitle,
    height = "100%",
    width,
    margin = 0,
    flexGrow = 0,
    overflowY = "hidden",
    buttons = null,
    contentPadding,
    infoTitle = Translations.Info,
    infoDocumentIsHtml = false,
    getInfoDocument,
    ...props
}: CardProps & {
  headerTitle?: string | ReactNode;
  height?: string | number;
  width?: string | number;
  margin?: string | number;
  flexGrow?: number;
  overflowY?: "hidden" | "visible" | "auto";
  buttons?: ReactNode;
  contentPadding?: string,
  infoTitle?: string,
  infoDocumentIsHtml?: boolean;
  getInfoDocument?: () => Promise<string>;
}) => {
    const handleInfoClick = async () => {
        const fileName = await AppUtils.callService(() => getInfoDocument(), !infoDocumentIsHtml);
        if (!fileName) return;
        if (!infoDocumentIsHtml) {
            AppUtils.showSuccessMessage(String.format(Translations.DocumentParameterDownloaded, fileName));
        } else {
            Base.openHtmlInNewTab(fileName);
        }
    };

    return (
        <Card
            elevation={1}
            sx={{
                height,
                width,
                border: "1px solid",
                borderColor: "divider",
                margin,
                flexGrow,
            }}
            {...props}
        >
            {headerTitle && (
                <CardHeader
                    sx={{ paddingRight: buttons ? ".5rem" : null }}
                    title={<Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
                        <Box>{headerTitle}</Box>
                        {!!buttons &&
                            <Box marginTop="-.5rem" marginBottom="-.5rem">
                                {buttons}
                            </Box>
                        }
                        {!!getInfoDocument &&
                            <Tooltip title={infoTitle}>
                                <AppInfoIcon
                                    color="info"
                                    sx={{ cursor: "pointer", marginRight: "-16px" }}
                                    onClick={handleInfoClick}
                                />
                            </Tooltip>
                        }
                    </Box>}
                    titleTypographyProps={{ variant: "body1", color: "text.secondary" }}
                />
            )}
            <CardContent
                sx={{
                    height: "calc(100% - 42px)",
                    overflowY,
                    display: overflowY === "hidden" ? "flex" : undefined,
                    flexDirection: overflowY === "hidden" ? "column" : undefined,
                    padding: contentPadding
                }}
            >
                {props.children}
            </CardContent>
        </Card>
    );
};